import React, { Component, useEffect, useState } from "react";
import ChatBot from "react-simple-chatbot";

import { ThemeProvider } from "styled-components";
import InputMessageBubble from "./bot_component/input";
import Logincheck from "./bot_component/authenications";
import Review from "./bot_component/review";
import Hellouser from "./bot_component/hellouser";
import Storedata from "./bot_component/storedata";
import ShareLockpdf from "./Tutorial_pdf/Sharelockpdf";
//? import login images
import RegisterLoginpdf from "./Tutorial_pdf/RegisterLoginpdf";
//? import subscribe plan images
import SubscribePlanGuidepdf from "./Tutorial_pdf/SubscribePlanGuidepdf";
//? import register/add lock images
import RegisterLockGuidepdf from "./Tutorial_pdf/RegisterLockGuidepdf";
//? import invite members images
import InviteMemberpdf from "./Tutorial_pdf/InviteMemberpdf";
//? import add recipient images
import AddRecipient from "./Tutorial_pdf/AddRecipientpdf";
//? import retract lock iamges
import RetractLock from "./Tutorial_pdf/RetractLockpdf";
//? import full guide iamges
import FullGuide from "./Tutorial_pdf/FullGuidepdf";
import Not_Found from "./bot_component/Not_Found";
import Extract from "./bot_component/extract";
// import CreateGroupGuidepdf from "./Tutorial_pdf/CreateGroupGuidepdf";
import AuditTrailGuidepdf from "./Tutorial_pdf/AuditTrailGuidepdf";
// import LogsGuidepdf from "./Tutorial_pdf/LogsGuidepdf";
// import RedemptionSamplepdf from "./Tutorial_pdf/RedemptionSamplepdf";

import { fire, auth } from "../../firebase/index";

import LocalizedStrings from "react-localization";

import Q1_component from "./bot_qns_comp/Q1_component";
import Q2_component from "./bot_qns_comp/Q2_component";
import Q3_component from "./bot_qns_comp/Q3_component";
import Q4_component from "./bot_qns_comp/Q4_component";
import Q5_component from "./bot_qns_comp/Q5_component";
import Q6_component from "./bot_qns_comp/Q6_component";
import Q7_component from "./bot_qns_comp/Q7_component";
import Q8_component from "./bot_qns_comp/Q8_component";
import Q9_component from "./bot_qns_comp/Q9_component";
import Q10_component from "./bot_qns_comp/Q10_component";
import Q11_component from "./bot_qns_comp/Q11_component";
import Q12_component from "./bot_qns_comp/Q12_component";
import Q13_component from "./bot_qns_comp/Q13_component";
import Q14_component from "./bot_qns_comp/Q14_component";
import Q15_component from "./bot_qns_comp/Q15_component";
import Q16_component from "./bot_qns_comp/Q16_component";
import Q17_component from "./bot_qns_comp/Q17_component";
import Q18_component from "./bot_qns_comp/Q18_component";
import Q19_component from "./bot_qns_comp/Q19_component";
import Q20_component from "./bot_qns_comp/Q20_component";
import Q21_component from "./bot_qns_comp/Q21_component";
import Q22_component from "./bot_qns_comp/Q22_component";
import Q23_component from "./bot_qns_comp/Q23_component";
import Q24_component from "./bot_qns_comp/Q24_component";
import Q25_component from "./bot_qns_comp/Q25_component";
import Q26_component from "./bot_qns_comp/Q26_component";
import Q27_component from "./bot_qns_comp/Q27_component";
import Lock from "./bot_qns_comp/lock_list_comp";
import User_Management_comp from "./bot_qns_comp/User_Management_comp";
import MultiApproval from "./bot_qns_comp/Multi_Approval";
import Audit_Trails from "./bot_qns_comp/Audit_Trails";
import Retract_Access from "./bot_qns_comp/Retract_Access";
import Plan_subscription from "./bot_qns_comp/Plan_subscription";
import GrantAccess from "./bot_qns_comp/Grant_Access";
import Audit_Trail_video from "./bot_vid_component/Audit_Trail_video";
import Grant_Acccess_Video from "./bot_vid_component/Grant_Acccess_Video";
import Introduction_video from "./bot_vid_component/introduction_video";
import Locklist_video from "./bot_vid_component/Locklist_video";
import Retract_Access_video from "./bot_vid_component/Retract_Access_video";
import Sign_up_video from "./bot_vid_component/Sign_up_video";
import User_Management_video from "./bot_vid_component/User_Management_video";

let localizationStrings = new LocalizedStrings({
  en: {
    chatHeader: "eGeeTouch's Robot",
    inputPlaceholder: "Enter your message",
    notLoggedIn1: "Welcome to eGeeTouch!",
    notLoggedIn2:
      "You are not logged in. Please enter your details to continue.",
    option1: "Instructions on the Intelligent Access Management System",
    option2: "Product Enquiries",
    option3: "Customer Support",
    search: "Search",
    back: "Back",
    yes: "Yes",
    no: "No",
    searching: "What are you searching for?",
    specificHelp: "Need more specific help",
    option1Reply: "Which set of instructions are you looking for?",
    option2Reply: "Which product are you enquiring about?",
    option3Reply: "Sure! Here's our contact information!",
    instructionsOption1: "Share lock / Multi-approval",
    instructionsOption2: "Register and Login",
    instructionsOption3: "Redeem / Subscribe to a plan",
    instructionsOption4: "Add a lock",
    instructionsOption5: "Invite members",
    instructionsOption6: "Add recipient",
    instructionsOption7: "Retract lock",
    instructionsOption8: "Full guide",
    instructionsOption9: "Video guide",
    videoGuideReply: "Which video guide would you like to watch?",
    videoOption1: "Intelligent Access Management Software Introduction",
    videoOption2: "How to sign up and subscribe to eGeeTouch IAM",
    videoOption3: "IAM Features - Locklist",
    videoOption4: "IAM Features - User Management",
    videoOption5: "IAM Features - Grant Acccess",
    videoOption6: "IAM Features - Retract Access",
    videoOption7: "IAM Features - Audit Trail",
    differentInstructions:
      "Do you want to view a different set of instructions?",
    differentVideo: "Do you want to view another video guide?",
    enquiryOption1: "Smart Lock",
    enquiryOption2: "Intelligent Access Management System",
    enquiryOption3: "Mobile App",
    lockOption1: "Granting access and accessing the lock",
    lockOption2: "Multi-approval",
    lockOption3: "Security Concerns",
    lockOption4: "Hardware Concerns",
    others: "Others",
    lockOption1Reply: "How can I assist you with the access function?",
    accessOption1: "How can I export access history data to a spreadsheet?",
    accessOption1Reply:
      'Go to the "Audit Trail" section in your account. Look for the "Export CSV" option and click on it. This action will open a popup with details to fill up. In the popup, provide the necessary details as requested, such as the date range or specific filters for the access history data you wish to export. After filling in the required information, proceed with the export process.',
    accessOption2: "How can I remotely disable access to a lock?",
    accessOption2Reply:
      'Go to the "Retract Access" section. Look for the checkbox next to the "Lock Name" and click on it to select the lock you want to remove access from. After selecting the lock, click on the "Remove Selected" button to proceed with the removal of access.',
    accessOption3: "How can I grant temporary access?",
    accessOption4: "How can I revoke access from a user?",
    accessOption4Reply:
      'Go to the "Retract Access" section. Look for the checkbox next to the "Lock Name" and click on it to select the lock you want to remove access from. After selecting the lock, click on the "Remove Selected" button to proceed with the removal of access.',
    accessOption5: "How can I set up one-time access to a lock for guests?",
    accessOption5Reply:
      'Go to the "Grant Access" section. Scroll down the page until you find the "One Time Access" toggle switch. Enable the toggle switch to make the lock accessible for one time.',
    lockOption2Reply: "How can I assist you with the multi-approval?",
    multiApprovalOption1: "What is multi-approval?",
    multiApprovalOption1Reply:
      "To ensure responsible shared access, you can designate approving members who must approve shared access before users can lock and unlock the padlock. This additional layer of authorization enhances security and control over who can access the padlock. By having approving members review and authorize shared access requests, you ensure that only authorized individuals can utilize the padlock.",
    multiApprovalOption2: "How does multi-approval enhance the security?",
    multiApprovalOption2Reply:
      "To ensure responsible shared access, you can designate approving members who must approve shared access before users can lock and unlock the padlock. This additional layer of authorization enhances security and control over who can access the padlock. By having approving members review and authorize shared access requests, you ensure that only authorized individuals can utilize the padlock.",
    lockOption3Reply: "What do you want to know about the lock security?",
    securityOption1:
      "Are there any security measures in place to protect my lock?",
    securityOption2: "How does multi-approval enhance the security?",
    securityOption2Reply:
      "To ensure responsible shared access, you can designate approving members who must approve shared access before users can lock and unlock the padlock. This additional layer of authorization enhances security and control over who can access the padlock. By having approving members review and authorize shared access requests, you ensure that only authorized individuals can utilize the padlock.",
    securityOption3:
      "How does the smart lock handle firmware updates and security patches?",
    securityOption4: "How can I track the access history of a lock?",
    securityOption4Reply:
      'Go to the "Audit Trail" section. Select the "Select Lock Admin" option to choose the administrator whose events you want to review. Then, select the "Select Lock Serial" option to choose the specific lock for which you want to see the history of events. Once you have made your selections, the system will display the audit trail, showing you all the relevant events associated with that particular lock.',
    lockOption4Reply: "What do you want to know about the hardware?",
    hardwareOption1:
      "What happens to my smart lock's battery when it loses all power?",
    hardwareOption2: "What type of batteries does the smart locks use?",
    hardwareOption3: "What is the lifespan of the smart locks batteries?",
    hardwareOption4: "Can I make a physical key for my lock?",
    hardwareOption5:
      "Can I use the smart lock with multiple smartphones or devices simultaneously?",
    lockOption5Reply:
      "Here are some frequently asked questions about our smart locks.",
    othersOption1: "How can I assign different names to each smart lock?",
    othersOption1Reply:
      'Go to the "Locklist" section. You will be presented with a list of locks associated with your account. Locate the lock you want to rename and double click on the "Name" box next to the lock. You can now enter your desired name or preference for the lock.',
    othersOption2:
      "What type of support and warranty is provided for the smart locks?",
    othersOption3: "What are recipients in the user management page for?",
    othersOption3Reply:
      "A recipient is a selected member with user role that is chosen/added by an admin member to be managed. A recipient/user may only lock & unlock using mobile app.",
    othersOption4: "Where can I find help or support resources on the website?",
    othersOption4Reply: "Please click on the link below for more information.",
    IAMSOption1: "Subscriptions",
    IAMSOption2: "Accounts management and settings",
    IAMSOption3: "Features of Intelligent Access Management System",
    IAMSOption1Reply: "How can I assist you with the subscription?",
    subscriptionOption1: "How do I cancel my subscription?",
    subscriptionOption1Reply:
      'Go to the "Plans Subscription" section and click on it. You will find two tabs: "Redemption Menu" and "Subscription Plans." Click on the "Subscription Plans" tab. Scroll down to the bottom of the website to find the "Cancel Subscription" option. Click on "Cancel Subscription" to proceed with the cancellation.',
    subscriptionOption2: "How do I switch my subscription plan?",
    subscriptionOption2Reply:
      'Go to the "Plans Subscription" section and click on it. You will find two tabs: "Redemption Menu" and "Subscription Plans." Click on the "Subscription Plans" tab to view all available subscription plans. Browse through the list of subscription plans to find the one that best suits your needs. Once you have decided on a new plan, click the "Switch Plan" button associated with that plan. Follow any further instructions or prompts to confirm the change of your subscription plan.',
    IAMSOption2Reply: "What help do you need with your account?",
    accountOption1: "How do I reset my password?",
    accountOption1Reply:
      "Proceed to the settings page to reset your password. To access the settings page, simply locate the gear icon at the top of the website and click on it. The settings page will then open, allowing you to customize your preferences and adjust various features as needed. If you have any further questions or need assistance, feel free to ask!",
    accountOption2: "How do I change my account settings?",
    accountOption2Reply:
      "Proceed to the settings page to change your account settings. To access the settings page, simply locate the gear icon at the top of the website and click on it. The settings page will then open, allowing you to customize your preferences and adjust various features as needed. If you have any further questions or need assistance, feel free to ask!",
    accountOption3: "How do I change the primary administrator or owner?",
    accountOption4: "How do I add and remove members?",
    accountOption4Reply:
      'Go to the "User Management" section. You will be directed to the "All Members" tab, which lists all the members. To add members, scroll down to the bottom of the page and click on "Add Member". To remove members, look for the checkbox next to the "Member Name" and click on it to select the member you want to remove. Once you have made your selection, click on the "Remove Selected" button to proceed with the removal of the member from the list.',
    accountOption5: "How do I switch the website's language?",
    accountOption5Reply:
      "On any page of the website, locate the language dropdown positioned next to the gear icon at the top of the website page. Click on the language dropdown to open the language selection menu. Currently, there are three language options available for translation, which are English, Japanese and Spanish. Choose your preferred language from the menu to switch the websites content to the selected language.",
    accountOption6:
      "How do I update my account settings, including my email address and notification preferences?",
    accountOption6Reply:
      "Proceed to the settings page to change your account settings. To access the settings page, simply locate the gear icon at the top of the website and click on it. The settings page will then open, allowing you to customize your preferences and adjust various features as needed. If you have any further questions or need assistance, feel free to ask!",
    IAMSOption3Reply: "How can I assist you with the system features?",
    featuresOption1: "How can I assign different names to each smart lock?",
    featuresOption1Reply:
      'Go to the "Locklist" section. You will be presented with a list of locks associated with your account. Locate the lock you want to rename and double click on the "Name" box next to the lock. You can now enter your desired name or preference for the lock.',
    featuresOption2: "How can I track the access history of a lock?",
    featuresOption2Reply:
      'Go to the "Audit Trail" section. Select the "Select Lock Admin" option to choose the administrator whose events you want to review. Then, select the "Select Lock Serial" option to choose the specific lock for which you want to see the history of events. Once you have made your selections, the system will display the audit trail, showing you all the relevant events associated with that particular lock.',
    featuresOption3: "How can I grant temporary access?",
    featuresOption4: "How can I remotely disable access to a lock?",
    featuresOption4Reply:
      'Go to the "Retract Access" section. Look for the checkbox next to the "Lock Name" and click on it to select the lock you want to remove access from. After selecting the lock, click on the "Remove Selected" button to proceed with the removal of access.',
    featuresOption5: "How can I set up one-time access to a lock for guests?",
    featuresOption5Reply:
      'Go to the "Grant Access" section. Scroll down the page until you find the "One Time Access" toggle switch. Enable the toggle switch to make the lock accessible for one time.',
    featuresOption6: "How do I add a smart lock to my account?",
    featuresOption6Reply:
      'Open the eGeeTouch Commercial app on your device. Ensure that Bluetooth and Location services are enabled for the app to function correctly. Look for the "Add Lock" option and click on it to initiate the process. Follow the on-screen instructions and prompts to complete the setup and add the lock to your account.',
    featuresOption7: "How do I remove a smart lock from my account?",
    featuresOption7Reply:
      'Go to the "Locklist" section in your account. You will be presented with a list of locks associated with your account. Locate the lock you want to delete and click the checkbox next to "Name". Click on the "Remove Selected" button to proceed with the removal of the lock.',
    featuresOption8: "How do I change the grant access mode?",
    featuresOption8Reply:
      'Go to the "Grant Access" section. Scroll down the page to find lock options such as "Sharing Mode" and "Access Period". Toggle the switches based on the your preferences to set the desired access permissions for the smart lock.',
    appOption1:
      "Is there a mobile app in addition to the web portal for managing smart locks?",
    appOption1Reply:
      'For Android devices, go to the Google Play Store. For iOS devices, go to the App Store. Search for "eGeeTouch Commercial App" in the respective stores search bar. Once you find the app, tap on the "Download" or "Install" button to begin the download process. After the download is complete, the app will be installed on your device, and you will be able to access our services through your mobile device.',
    furtherAssistance: "Please contact us for further assistance.",
    contactUs:
      "Sorry, I am unable help you with your enquiries, please contact us so we can provide assistance.",
    foundAnswer: "Hope you found the answer you were looking for.",
  },
  ja: {
    chatHeader: "eGeeTouch のロボット",
    inputPlaceholder: "メッセージを入力してください",
    notLoggedIn1: "eGeeTouchへようこそ！",
    notLoggedIn2:
      "ログインしていません。続行するには、詳細を入力してください。",
    option1: "システムの説明書",
    option2: "製品のお問い合わせ",
    option3: "カスタマーサポート",
    search: "検索",
    back: "戻る",
    yes: "はい",
    no: "いいえ",
    searching: "何を探していますか？",
    specificHelp: "より具体的なサポートが必要ですか",
    option1Reply: "どの指示を探していますか？",
    option2Reply: "どの製品についてのお問い合わせですか？",
    option3Reply: "もちろん！こちらが私たちの連絡先情報です。",
    instructionsOption1: "ロックの共有とマルチ承認",
    instructionsOption2: "新規登録・ログイン",
    instructionsOption3: "プラン選択・ご契約",
    instructionsOption4: "スマートロック登録",
    instructionsOption5: "メンバー登録",
    instructionsOption6: "受信者の追加",
    instructionsOption7: "アクセス権限解除",
    instructionsOption8: "完全ガイド",
    instructionsOption9: "ビデオガイド",
    videoGuideReply: "どのビデオガイドをご覧になりますか？",
    videoOption1: "インテリジェントアクセス管理ソフトウェアの紹介",
    videoOption2: "eGeeTouch IAMへの登録とサブスクリプション方法",
    videoOption3: "IAM機能 - ロックリスト",
    videoOption4: "IAM機能 - ユーザー管理",
    videoOption5: "IAM機能 - アクセス権の付与",
    videoOption6: "IAM機能 - アクセス権の取り消し",
    videoOption7: "IAM機能 - 監査記録",
    differentInstructions: "別の指示セットを見ますか？",
    differentVideo: "別のビデオガイドを見ますか？",
    enquiryOption1: "スマートロック",
    enquiryOption2: "インテリジェントアクセス管理システム",
    enquiryOption3: "モバイルアプリケーション",
    lockOption1: "アクセスの許可とロックへのアクセス",
    lockOption2: "マルチ承認",
    lockOption3: "セキュリティの懸念",
    lockOption4: "ハードウェアの懸念",
    others: "その他",
    lockOption1Reply: "アクセス機能についてどのようにお手伝いできますか？",
    accessOption1:
      "アクセス履歴データをスプレッドシートにエクスポートするにはどうすればよいですか？",
    accessOption1Reply:
      "アカウントの「監査証跡」セクションに移動します。 「CSV をエクスポート」オプションを探してクリックします。このアクションにより、入力する詳細を含むポップアップが開きます。ポップアップで、エクスポートするアクセス履歴データの日付範囲や特定のフィルターなど、要求に応じて必要な詳細を入力します。必要事項を入力後、エクスポート手続きを進めてください。",
    accessOption2:
      "ロックへのアクセスをリモートで無効にするにはどうすればよいですか？",
    accessOption2Reply:
      "「アクセスの撤回」セクションに進みます。 「ロック名」の横にあるチェックボックスを探し、それをクリックしてアクセスを削除するロックを選択します。ロックを選択した後、「選択項目を削除」ボタンをクリックしてアクセスの削除を続行します。",
    accessOption3: "一時的なアクセスを許可するにはどうすればよいですか？",
    accessOption4: "ユーザーからのアクセスを取り消すにはどうすればよいですか？",
    accessOption4Reply:
      "「アクセスの撤回」セクションに進みます。 「ロック名」の横にあるチェックボックスを探し、それをクリックしてアクセスを削除するロックを選択します。ロックを選択した後、「選択項目を削除」ボタンをクリックしてアクセスの削除を続行します。",
    accessOption5:
      "ゲストがロックにワンタイムアクセスできるように設定するにはどうすればよいですか？",
    accessOption5Reply:
      "「アクセスの許可」セクションに進みます。 「ワンタイムアクセス」トグルスイッチが見つかるまでページを下にスクロールします。トグル スイッチを有効にして、ロックに 1 回だけアクセスできるようにします。",
    lockOption2Reply: "マルチ承認についてどのようにお手伝いできますか？",
    multiApprovalOption1: "複数承認とは何ですか？",
    multiApprovalOption1Reply:
      "責任ある共有アクセスを保証するために、ユーザーが南京錠をロックおよびロック解除できる前に共有アクセスを承認する必要がある承認メンバーを指定できます。この追加の認証レイヤーにより、南京錠にアクセスできるユーザーのセキュリティと制御が強化されます。承認メンバーに共有アクセス要求をレビューして承認させることで、承認された個人のみが南京錠を利用できるようになります。",
    multiApprovalOption2:
      "複数承認によりセキュリティはどのように強化されますか？",
    multiApprovalOption2Reply:
      "責任ある共有アクセスを保証するために、ユーザーが南京錠をロックおよびロック解除できる前に共有アクセスを承認する必要がある承認メンバーを指定できます。この追加の認証レイヤーにより、南京錠にアクセスできるユーザーのセキュリティと制御が強化されます。承認メンバーに共有アクセス要求をレビューして承認させることで、承認された個人のみが南京錠を利用できるようになります。",
    lockOption3Reply: "ロックのセキュリティについて何を知りたいですか？",
    securityOption1: "私のロックを保護するためのセキュリティ対策はありますか？",
    securityOption2: "複数承認によりセキュリティはどのように強化されますか？",
    securityOption2Reply:
      "責任ある共有アクセスを保証するために、ユーザーが南京錠をロックおよびロック解除できる前に共有アクセスを承認する必要がある承認メンバーを指定できます。この追加の認証レイヤーにより、南京錠にアクセスできるユーザーのセキュリティと制御が強化されます。承認メンバーに共有アクセス要求をレビューして承認させることで、承認された個人のみが南京錠を利用できるようになります。",
    securityOption3:
      "スマート ロックはファームウェアのアップデートとセキュリティ パッチをどのように処理しますか？",
    securityOption4: "ロックのアクセス履歴を追跡するにはどうすればよいですか？",
    securityOption4Reply:
      "「監査証跡」セクションに移動します。 [ロック管理者の選択] オプションを選択して、イベントを確認する管理者を選択します。次に、[ロック シリアルの選択] オプションを選択して、イベントの履歴を表示する特定のロックを選択します。選択を行うと、システムは監査証跡を表示し、その特定のロックに関連するすべての関連イベントを示します。",
    lockOption4Reply: "ハードウェアについて何を知りたいですか？",
    hardwareOption1:
      "スマート ロックの電力がすべて失われると、バッテリーはどうなりますか？",
    hardwareOption2: "スマートロックにはどのような種類の電池が使用されますか？",
    hardwareOption3: "スマートロックの電池の寿命はどのくらいですか？",
    hardwareOption4: "ロック用の物理キーを作成できますか？",
    hardwareOption5:
      "スマートロックを複数のスマートフォンやデバイスで同時に使用できますか？",
    lockOption5Reply: "スマートロックに関するよくあるご質問をまとめました。",
    othersOption1:
      "各スマート ロックに異なる名前を割り当てるにはどうすればよいですか？",
    othersOption1Reply:
      "「ロックリスト」セクションに進みます。アカウントに関連付けられているロックのリストが表示されます。名前を変更したいロックを見つけて、ロックの横にある「名前」ボックスをダブルクリックします。ここで、ロックに希望の名前を入力できます。",
    othersOption2:
      "スマートロックにはどのようなサポートや保証が提供されますか？",
    othersOption3: "ユーザー管理ページの受信者は何のためにありますか",
    othersOption3Reply:
      "受信者は、管理者メンバーによって選択/追加されたユーザーの役割を持つメンバーです。受信者/ユーザーは、モバイルアプリを使用してのみロックとアンロックを行うことができます。",
    othersOption4:
      "ウェブサイトでヘルプやサポートリソースはどこで見つけられますか？",
    othersOption4Reply: "詳細については、下のリンクをクリックしてください。",
    IAMSOption1: "サブスクリプション",
    IAMSOption2: "アカウント管理と設定",
    IAMSOption3: "インテリジェントアクセス管理システムの機能",
    IAMSOption1Reply:
      "サブスクリプションについてどのようにお手伝いできますか？",
    subscriptionOption1:
      "サブスクリプションをキャンセルするにはどうすればよいですか？",
    subscriptionOption1Reply:
      "「プランのサブスクリプション」セクションに移動してクリックします。 「引き換えメニュー」と「サブスクリプションプラン」の 2 つのタブがあります。 「サブスクリプションプラン」タブをクリックします。 Web サイトの一番下までスクロールして、「サブスクリプションのキャンセル」オプションを見つけます。 「サブスクリプションをキャンセルする」をクリックしてキャンセルを進めます。",
    subscriptionOption2:
      "サブスクリプション プランを切り替えるにはどうすればよいですか？",
    subscriptionOption2Reply:
      "「プランのサブスクリプション」セクションに移動してクリックします。 「引き換えメニュー」と「サブスクリプションプラン」の 2 つのタブがあります。 [サブスクリプション プラン] タブをクリックして、利用可能なすべてのサブスクリプション プランを表示します。サブスクリプション プランのリストを参照して、ニーズに最適なものを見つけてください。新しいプランを決定したら、そのプランに関連付けられている「プランの切り替え」ボタンをクリックします。さらに指示やプロンプトがあれば、それに従ってサブスクリプション プランの変更を確認します。",
    IAMSOption2Reply: "アカウントに関してどのようにお手伝いできますか？",
    accountOption1: "パスワードをリセットするにはどうすればよいですか？",
    accountOption1Reply:
      "設定ページに進み、パスワードをリセットします。設定ページにアクセスするには、Web サイトの上部にある歯車アイコンを見つけてクリックするだけです。設定ページが開き、必要に応じて設定をカスタマイズしたり、さまざまな機能を調整したりできます。さらにご質問がある場合やサポートが必要な場合は、お気軽にお問い合わせください。",
    accountOption2: "アカウント設定を変更するにはどうすればよいですか？",
    accountOption2Reply:
      "設定ページに進み、アカウント設定を変更します。設定ページにアクセスするには、Web サイトの上部にある歯車アイコンを見つけてクリックするだけです。設定ページが開き、必要に応じて設定をカスタマイズしたり、さまざまな機能を調整したりできます。さらにご質問がある場合やサポートが必要な場合は、お気軽にお問い合わせください。",
    accountOption3:
      "プライマリ管理者または所有者を変更するにはどうすればよいですか？",
    accountOption4: "メンバーを追加および削除するにはどうすればよいですか？",
    accountOption4Reply:
      "「ユーザー管理」セクションに移動します。 [すべてのメンバー] タブが表示され、すべてのメンバーがリストされます。メンバーを追加するには、ページの一番下までスクロールし、[メンバーを追加] をクリックします。メンバーを削除するには、「メンバー名」の横にあるチェックボックスを探し、それをクリックして削除するメンバーを選択します。選択を行ったら、「選択項目を削除」ボタンをクリックして、リストからメンバーを削除します。",
    accountOption5: "ウェブサイトの言語を切り替えるにはどうすればよいですか？",
    accountOption5Reply:
      "Web サイトのどのページでも、Web サイトのページ上部にある歯車アイコンの横にある言語ドロップダウンを見つけます。言語ドロップダウンをクリックして言語選択メニューを開きます。現在、翻訳に利用できる言語オプションは、英語、日本語、スペイン語の 3 つです。メニューから希望の言語を選択すると、Web サイトのコンテンツが選択した言語に切り替わります。",
    accountOption6:
      "電子メール アドレスや通知設定などのアカウント設定を更新するにはどうすればよいですか？",
    accountOption6Reply:
      "設定ページに進み、アカウント設定を変更します。設定ページにアクセスするには、Web サイトの上部にある歯車アイコンを見つけてクリックするだけです。設定ページが開き、必要に応じて設定をカスタマイズしたり、さまざまな機能を調整したりできます。さらにご質問がある場合やサポートが必要な場合は、お気軽にお問い合わせください。",
    IAMSOption3Reply: "システム機能についてどのようにサポートできますか？",
    featuresOption1:
      "各スマート ロックに異なる名前を割り当てるにはどうすればよいですか？",
    featuresOption1Reply:
      "「ロックリスト」セクションに進みます。アカウントに関連付けられているロックのリストが表示されます。名前を変更したいロックを見つけて、ロックの横にある「名前」ボックスをダブルクリックします。ここで、ロックに希望の名前を入力できます。",
    featuresOption2: "ロックのアクセス履歴を追跡するにはどうすればよいですか？",
    featuresOption2Reply:
      "「監査証跡」セクションに移動します。 [ロック管理者の選択] オプションを選択して、イベントを確認する管理者を選択します。次に、[ロック シリアルの選択] オプションを選択して、イベントの履歴を表示する特定のロックを選択します。選択を行うと、システムは監査証跡を表示し、その特定のロックに関連するすべての関連イベントを示します。",
    featuresOption3: "一時的なアクセスを許可するにはどうすればよいですか？",
    featuresOption4:
      "ロックへのアクセスをリモートで無効にするにはどうすればよいですか？",
    featuresOption4Reply:
      "「アクセスの撤回」セクションに進みます。 「ロック名」の横にあるチェックボックスを探し、それをクリックしてアクセスを削除するロックを選択します。ロックを選択した後、「選択項目を削除」ボタンをクリックしてアクセスの削除を続行します。",
    featuresOption5:
      "ゲストがロックにワンタイムアクセスできるように設定するにはどうすればよいですか？",
    featuresOption5Reply:
      "「アクセスの許可」セクションに進みます。 「ワンタイムアクセス」トグルスイッチが見つかるまでページを下にスクロールします。トグル スイッチを有効にして、ロックに 1 回だけアクセスできるようにします。",
    featuresOption6:
      "アカウントにスマート ロックを追加するにはどうすればよいですか？",
    featuresOption6Reply:
      "デバイスで eGeeTouch Commercial アプリを開きます。アプリが正しく機能するには、Bluetooth および位置情報サービスが有効になっていることを確認してください。 「ロックの追加」オプションを探してクリックし、プロセスを開始します。画面上の指示とプロンプトに従ってセットアップを完了し、アカウントにロックを追加します。",
    featuresOption7:
      "アカウントからスマート ロックを削除するにはどうすればよいですか？",
    featuresOption7Reply:
      "アカウントの「ロックリスト」セクションに移動します。アカウントに関連付けられているロックのリストが表示されます。削除するロックを見つけて、「名前」の横にあるチェックボックスをクリックします。 「選択項目を削除」ボタンをクリックして、ロックの削除を続行します。",
    featuresOption8: "アクセス許可モードを変更するにはどうすればよいですか？",
    featuresOption8Reply:
      "「アクセスの許可」セクションに進みます。ページを下にスクロールして、「共有モード」や「アクセス期間」などのロック オプションを見つけます。好みに基づいてスイッチを切り替えて、スマート ロックに必要なアクセス許可を設定します。",
    appOption1:
      "スマートロックを管理するためのウェブポータルに加えてモバイルアプリはありますか？",
    appOption1Reply:
      "Androidデバイスの場合はGoogle Playストアにアクセスしてください。iOSデバイスの場合はApp Storeにアクセスしてください。各ストアの検索バーで「eGeeTouch Commercial App」を検索します。アプリを見つけたら、「ダウンロード」または「インストール」ボタンをタップしてダウンロードを開始します。ダウンロードが完了したら、アプリはデバイスにインストールされ、モバイルデバイスを通じてサービスにアクセスできるようになります。",
    furtherAssistance: "さらにサポートが必要な場合は、お問い合わせください。",
    contactUs:
      "申し訳ございませんが、お問い合わせにはお答えできません。サポートさせていただきますので、お気軽にお問い合わせください。",
    foundAnswer: "探していた答えが見つかることを願っています。",
  },
  es: {
    chatHeader: "Robot de eGeeTouch",
    inputPlaceholder: "Ingrese su mensaje",
    notLoggedIn1: "¡Bienvenido a eGeeTouch!",
    notLoggedIn2:
      "No has iniciado sesión. Por favor, ingresa tus datos para continuar.",
    option1: "Instrucciones sobre el Sistema de Gestión de Acceso Inteligente",
    option2: "Consultas sobre productos",
    option3: "Soporte al cliente",
    search: "Buscar",
    back: "Atrás",
    yes: "Sí",
    no: "No",
    searching: "¿Qué estás buscando?",
    specificHelp: "Necesita ayuda más específica",
    option1Reply: "¿Qué conjunto de instrucciones estás buscando?",
    option2Reply: "¿Sobre qué producto está haciendo la consulta?",
    option3Reply: "¡Claro! Aquí está nuestra información de contacto.",
    instructionsOption1: "Compartir acceso / Aprobación múltiple",
    instructionsOption2: "Registrarse e Iniciar sesión",
    instructionsOption3: "Canjear / Suscribirse a un plan",
    instructionsOption4: "Añadir un candado",
    instructionsOption5: "Invitar a miembros",
    instructionsOption6: "Añadir destinatario",
    instructionsOption7: "Retraer acceso",
    instructionsOption8: "Guía completa",
    instructionsOption9: "Guía en video",
    videoGuideReply: "¿Qué guía en video le gustaría ver?",
    videoOption1: "Introducción al software de Gestión de Acceso Inteligente",
    videoOption2: "Cómo registrarse y suscribirse a eGeeTouch IAM",
    videoOption3: "Funciones de IAM - Lista de Candados",
    videoOption4: "Funciones de IAM - Gestión de Usuarios",
    videoOption5: "Funciones de IAM - Conceder Acceso",
    videoOption6: "Funciones de IAM - Retirar Acceso",
    videoOption7: "Funciones de IAM - Registro de Auditoría",
    differentInstructions: "¿Quieres ver otro conjunto de instrucciones?",
    differentVideo: "¿Quieres ver otra guía de video?",
    enquiryOption1: "Candado Inteligente",
    enquiryOption2: "Sistema de Gestión de Acceso Inteligente",
    enquiryOption3: "Aplicación Móvil",
    lockOption1: "Conceder acceso y acceder al candado",
    lockOption2: "Aprobación múltiple",
    lockOption3: "Preocupaciones de seguridad",
    lockOption4: "Preocupaciones de hardware",
    others: "Otros",
    lockOption1Reply: "¿Cómo puedo ayudarte con el acceso a la candado?",
    accessOption1:
      "¿Cómo puedo exportar datos del historial de acceso a una hoja de cálculo?",
    accessOption1Reply:
      'Vaya a la sección "Registro de auditoría" de su cuenta. Busque la opción "Exportar CSV" y haga clic en ella. Esta acción abrirá una ventana emergente con detalles para completar. En la ventana emergente, proporcione los detalles necesarios según se le solicite, como el rango de fechas o filtros específicos para los datos del historial de acceso que desea exportar. Luego de completar la información requerida, continúe con el proceso de exportación.',
    accessOption2:
      "¿Cómo puedo desactivar remotamente el acceso a una candado?",
    accessOption2Reply:
      'Vaya a la sección "Revocar acceso". Busque la casilla de verificación junto a "Nombre de la candado" y haga clic en ella para seleccionar el candado del que desea eliminar el acceso. Después de seleccionar el candado, haga clic en el botón "Eliminar seleccionados" para continuar con la eliminación del acceso.',
    accessOption3: "¿Cómo puedo otorgar acceso temporal?",
    accessOption4: "¿Cómo puedo revocar el acceso de un usuario?",
    accessOption4Reply:
      'Vaya a la sección "Revocar acceso". Busque la casilla de verificación junto a "Nombre de la candado" y haga clic en ella para seleccionar el candado del que desea eliminar el acceso. Después de seleccionar el candado, haga clic en el botón "Eliminar seleccionados" para continuar con la eliminación del acceso.',
    accessOption5:
      "¿Cómo puedo configurar el acceso único a una candado para invitados?",
    accessOption5Reply:
      'Vaya a la sección "Otorgar acceso". Desplácese hacia abajo en la página hasta encontrar el interruptor de palanca "Acceso único". Habilite el interruptor de palanca para que la candado sea accesible por una sola vez.',
    lockOption2Reply: "¿Cómo puedo ayudarte con la aprobación múltiple?",
    multiApprovalOption1: "¿Qué es la aprobación múltiple?",
    multiApprovalOption1Reply:
      "Para garantizar un acceso compartido responsable, puede designar miembros aprobadores que deben aprobar el acceso compartido antes de que los usuarios puedan bloquear y desbloquear el candado. Esta capa adicional de autorización mejora la seguridad y el control sobre quién puede acceder al candado. Al hacer que los miembros aprobadores revisen y autoricen las solicitudes de acceso compartido, se asegura de que solo las personas autorizadas puedan utilizar el candado.",
    multiApprovalOption2: "¿Cómo mejora la seguridad la aprobación múltiple?",
    multiApprovalOption2Reply:
      "Para garantizar un acceso compartido responsable, puede designar miembros aprobadores que deben aprobar el acceso compartido antes de que los usuarios puedan bloquear y desbloquear el candado. Esta capa adicional de autorización mejora la seguridad y el control sobre quién puede acceder al candado. Al hacer que los miembros aprobadores revisen y autoricen las solicitudes de acceso compartido, se asegura de que solo las personas autorizadas puedan utilizar el candado.",
    lockOption3Reply: "¿Qué deseas saber sobre la seguridad del candado?",
    securityOption1: "¿Existen medidas de seguridad para proteger mi candado?",
    securityOption2: "¿Cómo mejora la seguridad la aprobación múltiple?",
    securityOption2Reply:
      "Para garantizar un acceso compartido responsable, puede designar miembros aprobadores que deben aprobar el acceso compartido antes de que los usuarios puedan bloquear y desbloquear el candado. Esta capa adicional de autorización mejora la seguridad y el control sobre quién puede acceder al candado. Al hacer que los miembros aprobadores revisen y autoricen las solicitudes de acceso compartido, se asegura de que solo las personas autorizadas puedan utilizar el candado.",
    securityOption3:
      "¿Cómo maneja la candado inteligente las actualizaciones de firmware y los parches de seguridad?",
    securityOption4:
      "¿Cómo puedo rastrear el historial de acceso de una candado?",
    securityOption4Reply:
      'Vaya a la sección "Registro de auditoría". Seleccione la opción "Selecciona el Administrador de la Candado" para elegir el administrador cuyos eventos desea revisar. Luego, seleccione la opción "Selecciona tu Número de Serie de la Candado" para elegir el candado específico del cual desea ver el historial de eventos. Una vez que haya realizado sus selecciones, el sistema mostrará el registro de auditoría, mostrándole todos los eventos relevantes asociados con ese candado en particular.',
    lockOption4Reply: "¿Qué deseas saber sobre el hardware?",
    hardwareOption1:
      "¿Qué sucede con la batería de mi candado inteligente cuando se queda sin energía?",
    hardwareOption2:
      "¿Qué tipo de baterías utilizan las candados inteligentes?",
    hardwareOption3:
      "¿Cuál es la vida útil de las baterías de las candados inteligentes?",
    hardwareOption4: "¿Puedo hacer una llave física para mi candado?",
    hardwareOption5:
      "¿Puedo utilizar la candado inteligente con varios smartphones o dispositivos simultáneamente?",
    lockOption5Reply:
      "A continuación se incluyen algunas preguntas frecuentes sobre nuestras candados inteligentes.",
    othersOption1:
      "¿Cómo puedo asignar diferentes nombres a cada candado inteligente?",
    othersOption1Reply:
      'Vaya a la sección "Lista de Candados". Se le presentará una lista de candados asociados con su cuenta. Localice el candado cuyo nombre desea cambiar y haga doble clic en el cuadro "Nombre" al lado del candado. Ahora puede ingresar el nombre que desee para la candado.',
    othersOption2:
      "¿Qué tipo de soporte y garantía se proporciona para las candados inteligentes?",
    othersOption3:
      "¿Para qué sirven los destinatarios en la página de administración de usuarios?",
    othersOption3Reply:
      "Un destinatario es un miembro seleccionado con el rol de usuario que ha sido elegido/agregado por un miembro administrador para ser gestionado. Un destinatario/usuario solo puede bloquear y desbloquear usando la aplicación móvil.",
    othersOption4:
      "¿Dónde puedo encontrar ayuda o recursos de soporte en el sitio web?",
    othersOption4Reply:
      "Haga clic en el enlace a continuación para obtener más información.",
    IAMSOption1: "Suscripciones",
    IAMSOption2: "Gestión de cuentas y configuraciones",
    IAMSOption3: "Funciones del Sistema de Gestión de Acceso Inteligente",
    IAMSOption1Reply: "¿Cómo puedo ayudarte con la suscripción?",
    subscriptionOption1: "¿Cómo cancelo mi suscripción?",
    subscriptionOption1Reply:
      'Vaya a la sección "Suscripción de Planes" y haga clic en ella. Encontrarás dos pestañas: "Menú de canje" y "Planes de suscripción". Haga clic en la pestaña "Planes de suscripción". Desplácese hasta la parte inferior del sitio web para encontrar la opción "Cancelar suscripción". Haga clic en "Cancelar suscripción" para proceder con la cancelación.',
    subscriptionOption2: "¿Cómo cambio mi plan de suscripción?",
    subscriptionOption2Reply:
      'Vaya a la sección "Suscripción de Planes" y haga clic en ella. Encontrarás dos pestañas: "Menú de canje" y "Planes de suscripción". Haga clic en la pestaña "Planes de suscripción" para ver todos los planes de suscripción disponibles. Navega por la lista de planes de suscripción para encontrar el que mejor se adapte a tus necesidades. Una vez que haya decidido un nuevo plan, haga clic en el botón "Cambiar de plan" asociado con ese plan. Siga las instrucciones o indicaciones adicionales para confirmar el cambio de su plan de suscripción.',
    IAMSOption2Reply: "¿Qué ayuda necesitas con tu cuenta?",
    accountOption1: "¿Cómo restablezco mi contraseña?",
    accountOption1Reply:
      "Vaya a la página de configuración para restablecer su contraseña. Para acceder a la página de configuración, simplemente ubique el ícono de ajustes en la parte superior del sitio web y haga clic en él. Luego se abrirá la página de configuración, que le permitirá personalizar sus preferencias y ajustar varias funciones según sea necesario. Si tiene más preguntas o necesita ayuda, ¡no dude en preguntar!",
    accountOption2: "¿Cómo cambio la configuración de mi cuenta?",
    accountOption2Reply:
      "Vaya a la página de configuración para cambiar la configuración de su cuenta. Para acceder a la página de configuración, simplemente ubique el ícono de ajustes en la parte superior del sitio web y haga clic en él. Luego se abrirá la página de configuración, que le permitirá personalizar sus preferencias y ajustar varias funciones según sea necesario. Si tiene más preguntas o necesita ayuda, ¡no dude en preguntar!",
    accountOption3: "¿Cómo cambio el administrador principal o el propietario?",
    accountOption4: "¿Cómo agrego y elimino miembros?",
    accountOption4Reply:
      'Vaya a la sección "Gestión de Usuarios". Se lo dirigirá a la pestaña "Todos los miembros", que enumera a todos los miembros. Para agregar miembros, desplácese hacia abajo hasta la parte inferior de la página y haga clic en "Agregar miembro". Para eliminar miembros, busque la casilla de verificación junto al "Nombre del miembro" y haga clic en ella para seleccionar el miembro que desea eliminar. Una vez que haya hecho su selección, haga clic en el botón "Eliminar seleccionados" para proceder con la eliminación del miembro de la lista.',
    accountOption5: "¿Cómo cambio el idioma del sitio web?",
    accountOption5Reply:
      "En cualquier página del sitio web, ubique el menú desplegable de idiomas ubicado junto al ícono de ajustes en la parte superior de la página del sitio web. Haga clic en el menú desplegable de idioma para abrir el menú de selección de idioma. Actualmente, hay tres opciones de idiomas disponibles para la traducción: inglés, japonés y español. Elija su idioma preferido en el menú para cambiar el contenido del sitio web al idioma seleccionado.",
    accountOption6:
      "¿Cómo actualizo la configuración de mi cuenta, incluida mi dirección de correo electrónico y mis preferencias de notificación?",
    accountOption6Reply:
      "Vaya a la página de configuración para cambiar la configuración de su cuenta. Para acceder a la página de configuración, simplemente ubique el ícono de ajustes en la parte superior del sitio web y haga clic en él. Luego se abrirá la página de configuración, que le permitirá personalizar sus preferencias y ajustar varias funciones según sea necesario. Si tiene más preguntas o necesita ayuda, ¡no dude en preguntar!",
    IAMSOption3Reply: "¿Cómo puedo ayudarte con las funciones del sistema?",
    featuresOption1:
      "¿Cómo puedo asignar diferentes nombres a cada candado inteligente?",
    featuresOption1Reply:
      'Vaya a la sección "Lista de Candados". Se le presentará una lista de candados asociados con su cuenta. Localice el candado cuyo nombre desea cambiar y haga doble clic en el cuadro "Nombre" al lado del candado. Ahora puede ingresar el nombre que desee para la candado.',
    featuresOption2:
      "¿Cómo puedo rastrear el historial de acceso de una candado?",
    featuresOption2Reply:
      'Vaya a la sección "Registro de auditoría". Seleccione la opción "Selecciona el Administrador de la Candado" para elegir el administrador cuyos eventos desea revisar. Luego, seleccione la opción "Selecciona tu Número de Serie de la Candado" para elegir el candado específico del cual desea ver el historial de eventos. Una vez que haya realizado sus selecciones, el sistema mostrará el registro de auditoría, mostrándole todos los eventos relevantes asociados con ese candado en particular.',
    featuresOption3: "¿Cómo puedo otorgar acceso temporal?",
    featuresOption4:
      "¿Cómo puedo desactivar remotamente el acceso a una candado?",
    featuresOption4Reply:
      'Vaya a la sección "Revocar acceso". Busque la casilla de verificación junto a "Nombre de la candado" y haga clic en ella para seleccionar el candado del que desea eliminar el acceso. Después de seleccionar el candado, haga clic en el botón "Eliminar seleccionados" para continuar con la eliminación del acceso.',
    featuresOption5:
      "¿Cómo puedo configurar el acceso único a una candado para invitados?",
    featuresOption5Reply:
      'Vaya a la sección "Otorgar acceso". Desplácese hacia abajo en la página hasta encontrar el interruptor de palanca "Acceso único". Habilite el interruptor de palanca para que la candado sea accesible por una sola vez.',
    featuresOption6: "¿Cómo agrego una candado inteligente a mi cuenta?",
    featuresOption6Reply:
      'Abra la aplicación eGeeTouch Commercial en su dispositivo. Asegúrese de que los servicios Bluetooth y de ubicación estén habilitados para que la aplicación funcione correctamente. Busque la opción "Agregar candado" y haga clic en ella para iniciar el proceso. Siga las instrucciones y las indicaciones que aparecen en pantalla para completar la configuración y agregar el candado a su cuenta.',
    featuresOption7: "¿Cómo elimino una candado inteligente de mi cuenta?",
    featuresOption7Reply:
      'Vaya a la sección "Lista de Candados" de su cuenta. Se le presentará una lista de candados asociados con su cuenta. Localice el candado que desea eliminar y haga clic en la casilla de verificación junto a "Nombre". Haga clic en el botón "Eliminar seleccionados" para continuar con la eliminación del candado.',
    featuresOption8: "¿Cómo cambio el modo de concesión de acceso?",
    featuresOption8Reply:
      'Vaya a la sección "Otorgar acceso". Desplácese hacia abajo en la página para encontrar opciones de candado como "Modo compartido" y "Período de acceso". Cambie los interruptores según sus preferencias para configurar los permisos de acceso deseados para la candado inteligente.',
    appOption1:
      "¿Hay una aplicación móvil además del portal web para gestionar los candados inteligentes?",
    appOption1Reply:
      'Para dispositivos Android, ve a la Google Play Store. Para dispositivos iOS, ve a la App Store. Busca "eGeeTouch Commercial App" en la barra de búsqueda de las respectivas tiendas. Una vez que encuentres la aplicación, toca el botón "Descargar" o "Instalar" para comenzar el proceso de descarga. Después de que la descarga se complete, la aplicación se instalará en tu dispositivo y podrás acceder a nuestros servicios a través de tu dispositivo móvil.',
    furtherAssistance: "Por favor contáctenos para obtener más ayuda.",
    contactUs:
      "Lo sentimos, no puedo ayudarle con sus consultas, comuníquese con nosotros para que podamos brindarle asistencia.",
    foundAnswer: "Espero que encuentres la respuesta que estabas buscando.",
  },
});

const Bot = (props) => {
  const [language, setLanguage] = useState("en");

  useEffect(() => {
    const user = auth.currentUser;

    if (user) {
      const languageRef = fire
        .database()
        .ref("userSettings")
        .child(user.uid)
        .child("language");

      const listener = languageRef.on("value", (snapshot) => {
        const newLanguage = snapshot.val();
        if (newLanguage) {
          localizationStrings.setLanguage(newLanguage);
          setLanguage(newLanguage);
        }
      });

      return () => {
        languageRef.off("value", listener);
      };
    }
  }, []);

  // useEffect(() => {
  // console.log("Language: " + language);
  // }, [language]);

  const theme = {
    background: "#f5f8fb",
    fontFamily: "Helvetica Neue",
    headerBgColor: "orange",
    headerFontColor: "#fff",
    headerFontSize: "15px",
    botBubbleColor: "orange",
    botFontColor: "black",
    userBubbleColor: "#fff",
    userFontColor: "#4a4a4a",
  };

  const customStyles = `
    .bnaAlo {
      max-width: unset !important;
      width: 246px !important; 
      margin: -8px 0 10px 40px !important; 
      font-size: 14px !important; 
      font-family: "Nunito Sans", "Roboto","Helvetica Neue",Arial,sans-serif !important; 
    }
    .cxkZyO {
      max-width: unset !important;
      width: 246px !important; 
      font-size: 14px !important; 
      font-family: "Nunito Sans", "Roboto","Helvetica Neue",Arial,sans-serif !important; 
    }
    .jZddLa{
      max-width: unset !important;
      width: 246px !important; 
      margin: -8px 0 10px 40px !important; 
      font-size: 14px !important; 
      font-family: "Nunito Sans", "Roboto","Helvetica Neue",Arial,sans-serif !important; 
    }
    .gmfszQ{
      width: 250px !important; 
      margin: -8px 0 10px 42px !important; 
      font-size: 14px !important; 
      font-family: "Nunito Sans", "Roboto","Helvetica Neue",Arial,sans-serif !important; 
    }
    .iOCYje{
      max-width: 68% !important;
      margin: 0 0 10px 0 !important; 
      font-size: 14px !important; 
      font-family: "Nunito Sans", "Roboto","Helvetica Neue",Arial,sans-serif !important; 
    }
  `;

  const bubbleOptionStyle = {
    background: "#FAD7A0",
    color: "black",
    fontSize: "16px",
    borderRadius: "20px",
    cursor: "pointer",
    transition: "background 0.5s ease",
  };
  // const bubbleOptionStyle = {
  //   background: '#FF8000',
  //   color: 'white',
  //   fontSize: '16px',
  //   borderRadius: '20px',
  //   cursor: 'pointer',
  //   transition: 'background 0.5s ease',
  // };

  const steps = [
    {
      id: "authentication",
      component: <Logincheck />,
      asMessage: true,
      trigger: () => {
        const user = auth.currentUser;
        return user ? "login" : "not_login";
      },
    },
    {
      id: "not_login",
      message: localizationStrings.notLoggedIn1,
      trigger: "not_login_1",
    },
    {
      id: "not_login_1",
      message: localizationStrings.notLoggedIn2,
      trigger: "not_login_2",
    },
    {
      id: "not_login_2",
      component: <InputMessageBubble />,
      asMessage: true,
    },
    {
      id: "not_login_3",
      component: <Review />,
      asMessage: true,
    },
    {
      id: "not_login_4",
      component: <Hellouser />,
      asMessage: true,
      trigger: "login",
    },
    {
      id: "login",
      options: [
        {
          value: 1,
          label: localizationStrings.option1,
          trigger: "instruction_qns",
        },
        {
          value: 2,
          label: localizationStrings.option2,
          trigger: "product_questions",
        },
        {
          value: 3,
          label: localizationStrings.option3,
          trigger: "customer_support",
        },
        {
          value: 4,
          label: localizationStrings.search,
          trigger: "Search",
        },
        {
          value: 5,
          label: localizationStrings.back,
          trigger: "authentication",
        },
      ],
    },
    {
      id: "product_questions",
      message: localizationStrings.option2Reply,
      trigger: "problem_questions",
    },
    {
      id: "customer_support",
      message: localizationStrings.option3Reply,
      trigger: "contact_info",
    },
    {
      id: "contact_info",
      component: (
        <div>
          <div style={{ height: "12px" }} />
          <p>Tel: (1) 949 558 0160</p>
          <p>Fax: (1) 949 271 5701</p>
          <p>Email: info@egeetouch.com</p>
        </div>
      ),
      trigger: "authentication",
    },
    {
      id: "instruction_qns",
      message: localizationStrings.option1Reply,
      trigger: "instruction_pdf",
    },
    {
      id: "instruction_pdf",
      options: [
        {
          value: 1,
          label: localizationStrings.instructionsOption1,
          trigger: "sharelock_ins",
        },
        {
          value: 2,
          label: localizationStrings.instructionsOption2,
          trigger: "Register_ins",
        },
        {
          value: 3,
          label: localizationStrings.instructionsOption3,
          trigger: "Subscription_ins",
        },
        {
          value: 4,
          label: localizationStrings.instructionsOption4,
          trigger: "RegisterLock_ins",
        },
        {
          value: 5,
          label: localizationStrings.instructionsOption5,
          trigger: "Invite_ins",
        },
        {
          value: 6,
          label: localizationStrings.instructionsOption6,
          trigger: "Reciepient_ins",
        },
        {
          value: 7,
          label: localizationStrings.instructionsOption7,
          trigger: "RetractLock_ins",
        },
        {
          value: 8,
          label: localizationStrings.instructionsOption8,
          trigger: "Full_ins",
        },
        {
          value: 9,
          label: localizationStrings.instructionsOption9,
          trigger: "videos",
        },
        // {
        //   value: 10,
        //   label : 'Create Group Guide',
        //   trigger: 'CreateGroupGuide_ins',
        // },
        // {
        //   value: 11,
        //   label : 'Audit Trail Guide',
        //   trigger: 'AuditTrailGuide_ins',
        // },
        // {
        //   value: 12,
        //   label : 'Logs Guide',
        //   trigger: 'LogsGuide_ins',
        // },
        // {
        //   value: 13,
        //   label : 'Redemption Sample',
        //   trigger: 'RedemptionSample_ins',
        // },
        {
          value: 14,
          label: localizationStrings.search,
          trigger: "Search",
        },
        {
          value: 15,
          label: localizationStrings.back,
          trigger: "authentication",
        },
      ],
    },
    {
      id: "videos",
      message: localizationStrings.videoGuideReply,
      trigger: "videos_show",
    },
    {
      id: "videos_show",
      options: [
        {
          value: 1,
          label: localizationStrings.videoOption1,
          trigger: "Introduction_video",
        },
        {
          value: 2,
          label: localizationStrings.videoOption2,
          trigger: "Sign_up_video",
        },
        {
          value: 3,
          label: localizationStrings.videoOption3,
          trigger: "Locklist_video",
        },
        {
          value: 4,
          label: localizationStrings.videoOption4,
          trigger: "User_Management_video",
        },
        {
          value: 5,
          label: localizationStrings.videoOption5,
          trigger: "Grant_Acccess_Video",
        },
        {
          value: 6,
          label: localizationStrings.videoOption6,
          trigger: "Retract_Access_video",
        },
        {
          value: 7,
          label: localizationStrings.videoOption7,
          trigger: "Audit_Trail_video",
        },
        // {
        //   value: 8,
        //   label : 'Locklist video',
        //   trigger: 'Locklist_video',
        // },
        // {
        //   value: 9,
        //   label : 'Locklist video',
        //   trigger: 'Locklist_video',
        // },
        // {
        //   value: 10,
        //   label : 'Locklist video',
        //   trigger: 'Locklist_video',
        // },
        // {
        //   value: 11,
        //   label : 'Locklist video',
        //   trigger: 'Locklist_video',
        // },
        // {
        //   value: 12,
        //   label : 'Locklist video',
        //   trigger: 'Locklist_video',
        // },
        // {
        //   value: 13,
        //   label : 'Locklist video',
        //   trigger: 'Locklist_video',
        // },
        // {
        //   value: 14,
        //   label : 'Locklist video',
        //   trigger: 'Locklist_video',
        // },
        // {
        //   value: 15,
        //   label : 'Locklist video',
        //   trigger: 'Locklist_video',
        // },
        {
          value: 16,
          label: localizationStrings.search,
          trigger: "Search",
        },
        {
          value: 17,
          label: localizationStrings.back,
          trigger: "instruction_qns",
        },
      ],
    },
    {
      id: "Sign_up_video",
      component: <Sign_up_video />,
      asMessage: true,
      trigger: "review_video",
    },
    {
      id: "Introduction_video",
      component: <Introduction_video />,
      asMessage: true,
      trigger: "review_video",
    },
    {
      id: "Locklist_video",
      component: <Locklist_video />,
      asMessage: true,
      trigger: "review_video",
    },
    {
      id: "User_Management_video",
      component: <User_Management_video />,
      asMessage: true,
      trigger: "review_video",
    },
    {
      id: "Grant_Acccess_Video",
      component: <Grant_Acccess_Video />,
      asMessage: true,
      trigger: "review_video",
    },
    {
      id: "Retract_Access_video",
      component: <Retract_Access_video />,
      asMessage: true,
      trigger: "review_video",
    },
    {
      id: "Audit_Trail_video",
      component: <Audit_Trail_video />,
      asMessage: true,
      trigger: "review_video",
    },
    {
      id: "review_video",
      message: localizationStrings.differentVideo,
      trigger: "video?",
    },
    {
      id: "video?",
      options: [
        {
          value: 1,
          label: localizationStrings.yes,
          trigger: "videos",
        },
        {
          value: 2,
          label: localizationStrings.no,
          trigger: "2ndlogin",
        },
      ],
    },
    // {
    //   id: 'CreateGroupGuide_ins',
    //   component: <CreateGroupGuidepdf />,
    //   asMessage: true,
    //   trigger: 'instruction?',
    // },
    {
      id: "AuditTrailGuide_ins",
      component: <AuditTrailGuidepdf />,
      asMessage: true,
    },
    // {
    //   id: 'LogsGuide_ins',
    //   component: <LogsGuidepdf />,
    //   asMessage: true,
    //   trigger: 'instruction?',
    // },
    // {
    //   id: 'RedemptionSample_ins',
    //   component: <RedemptionSamplepdf />,
    //   asMessage: true,
    //   trigger: 'instruction?',
    // },
    {
      id: "sharelock_ins",
      component: <ShareLockpdf />,
      asMessage: true,
      trigger: "instruction?",
    },
    {
      id: "Register_ins",
      component: <RegisterLoginpdf />,
      asMessage: true,
      trigger: "instruction?",
    },
    {
      id: "Subscription_ins",
      component: <SubscribePlanGuidepdf />,
      asMessage: true,
      trigger: "instruction?",
    },
    {
      id: "RegisterLock_ins",
      component: <RegisterLockGuidepdf />,
      asMessage: true,
      trigger: "instruction?",
    },
    {
      id: "Invite_ins",
      component: <InviteMemberpdf />,
      asMessage: true,
      trigger: "instruction?",
    },
    {
      id: "Reciepient_ins",
      component: <AddRecipient />,
      asMessage: true,
      trigger: "instruction?",
    },
    {
      id: "RetractLock_ins",
      component: <RetractLock />,
      asMessage: true,
      trigger: "instruction?",
    },
    {
      id: "Full_ins",
      component: <FullGuide />,
      asMessage: true,
      trigger: "instruction?",
    },
    {
      id: "instruction?",
      message: localizationStrings.differentInstructions,
      trigger: "ins_choices",
    },
    {
      id: "ins_choices",
      options: [
        {
          value: 1,
          label: localizationStrings.yes,
          trigger: "instruction_qns",
        },
        {
          value: 2,
          label: localizationStrings.no,
          trigger: "2ndlogin",
        },
      ],
    },
    {
      id: "2ndlogin",
      component: <Logincheck />,
      asMessage: true,
      trigger: () => {
        const user = auth.currentUser;
        return user ? "login" : "not_login_4";
      },
    },
    {
      id: "problem_questions",
      options: [
        {
          value: 1,
          label: localizationStrings.enquiryOption1,
          trigger: "STORAGE",
        },
        {
          value: 2,
          label: localizationStrings.enquiryOption2,
          trigger: "STORAGE",
        },
        {
          value: 3,
          label: localizationStrings.enquiryOption3,
          trigger: "STORAGE",
        },
        {
          value: 4,
          label: localizationStrings.search,
          trigger: "Search",
        },
        {
          value: 5,
          label: localizationStrings.back,
          trigger: "authentication",
        },
      ],
    },
    {
      id: "STORAGE",
      component: <Storedata />,
      asMessage: true,
    },
    {
      id: "lock-choices",
      options: [
        {
          value: 1,
          label: localizationStrings.lockOption1,
          trigger: "15",
        },
        {
          value: 2,
          label: localizationStrings.lockOption2,
          trigger: "16",
        },
        {
          value: 3,
          label: localizationStrings.lockOption3,
          trigger: "17",
        },
        {
          value: 4,
          label: localizationStrings.lockOption4,
          trigger: "18",
        },
        {
          value: 5,
          label: localizationStrings.others,
          trigger: "19",
        },
        {
          value: 6,
          label: localizationStrings.search,
          trigger: "Search",
        },
        {
          value: 7,
          label: localizationStrings.back,
          trigger: "product_questions",
        },
      ],
    },
    {
      id: "web-choices",
      options: [
        {
          value: 1,
          label: localizationStrings.IAMSOption1,
          trigger: "12",
        },
        {
          value: 2,
          label: localizationStrings.IAMSOption2,
          trigger: "13",
        },
        {
          value: 3,
          label: localizationStrings.IAMSOption3,
          trigger: "locks-features",
        },
        {
          value: 4,
          label: localizationStrings.search,
          trigger: "Search",
        },
        {
          value: 5,
          label: localizationStrings.back,
          trigger: "product_questions",
        },
      ],
    },
    {
      id: "mobile-choices",
      options: [
        {
          value: 1,
          label: localizationStrings.appOption1,
          trigger: "50",
        },
        {
          value: 2,
          label: localizationStrings.search,
          trigger: "Search",
        },
        {
          value: 3,
          label: localizationStrings.back,
          trigger: "product_questions",
        },
      ],
    },
    {
      id: "12", // subscription choices
      message: localizationStrings.IAMSOption1Reply,
      trigger: "subscription-choices",
    },
    {
      id: "subscription-choices",
      options: [
        {
          value: 1,
          label: localizationStrings.subscriptionOption1,
          trigger: "39",
        },
        {
          value: 2,
          label: localizationStrings.subscriptionOption2,
          trigger: "40",
        },
        {
          value: 3,
          label: localizationStrings.specificHelp,
          trigger: "further_assistance",
        },
        {
          value: 4,
          label: localizationStrings.search,
          trigger: "Search",
        },
        {
          value: 5,
          label: localizationStrings.back,
          trigger: "STORAGE",
        },
      ],
    },
    {
      id: "locks-features",
      message: localizationStrings.IAMSOption3Reply,
      trigger: "locks-choices",
    },
    {
      id: "locks-choices",
      options: [
        {
          value: 1,
          label: localizationStrings.featuresOption1,
          trigger: "34",
        },
        {
          value: 2,
          label: localizationStrings.featuresOption2,
          trigger: "52",
        },
        {
          value: 3,
          label: localizationStrings.featuresOption3,
          trigger: "22",
        },
        {
          value: 4,
          label: localizationStrings.featuresOption4,
          trigger: "21",
        },
        {
          value: 5,
          label: localizationStrings.featuresOption5,
          trigger: "53",
        },
        {
          value: 6,
          label: localizationStrings.featuresOption6,
          trigger: "smart_lock",
        },
        {
          value: 7,
          label: localizationStrings.featuresOption7,
          trigger: "54",
        },
        {
          value: 8,
          label: localizationStrings.featuresOption8,
          trigger: "48",
        },
        {
          value: 10,
          label: localizationStrings.specificHelp,
          trigger: "further_assistance",
        },
        {
          value: 11,
          label: localizationStrings.search,
          trigger: "Search",
        },
        {
          value: 12,
          label: localizationStrings.back,
          trigger: "STORAGE",
        },
      ],
    },
    {
      id: "13", // account choices
      message: localizationStrings.IAMSOption2Reply,
      trigger: "account-choices",
    },
    {
      id: "account-choices",
      options: [
        {
          value: 1,
          label: localizationStrings.accountOption1,
          trigger: "42",
        },
        {
          value: 2,
          label: localizationStrings.accountOption2,
          trigger: "43",
        },
        {
          value: 4,
          label: localizationStrings.accountOption3,
          trigger: "44",
        },
        {
          value: 5,
          label: localizationStrings.accountOption4,
          trigger: "45",
        },
        {
          value: 6,
          label: localizationStrings.accountOption5,
          trigger: "46",
        },
        {
          value: 7,
          label: localizationStrings.accountOption6,
          trigger: "49",
        },
        {
          value: 10,
          label: localizationStrings.specificHelp,
          trigger: "further_assistance",
        },
        {
          value: 11,
          label: localizationStrings.search,
          trigger: "Search",
        },
        {
          value: 12,
          label: localizationStrings.back,
          trigger: "STORAGE",
        },
      ],
    },
    {
      id: "15", // access-choices
      message: localizationStrings.lockOption1Reply,
      trigger: "access-choices",
    },
    {
      id: "access-choices",
      options: [
        {
          value: 1,
          label: localizationStrings.accessOption1,
          trigger: "20",
        },
        {
          value: 2,
          label: localizationStrings.accessOption2,
          trigger: "21",
        },
        {
          value: 3,
          label: localizationStrings.accessOption3,
          trigger: "22",
        },
        {
          value: 4,
          label: localizationStrings.accessOption4,
          trigger: "23",
        },
        {
          value: 5,
          label: localizationStrings.accessOption5,
          trigger: "53",
        },
        {
          value: 6,
          label: localizationStrings.specificHelp,
          trigger: "further_assistance",
        },
        {
          value: 7,
          label: localizationStrings.search,
          trigger: "Search",
        },
        {
          value: 8,
          label: localizationStrings.back,
          trigger: "STORAGE",
        },
      ],
    },
    {
      id: "16", //multi-approval choices
      message: localizationStrings.lockOption2Reply,
      trigger: "multi-approval-choices",
    },
    {
      id: "multi-approval-choices",
      options: [
        {
          value: 1,
          label: localizationStrings.multiApprovalOption1,
          trigger: "25",
        },
        {
          value: 2,
          label: localizationStrings.multiApprovalOption2,
          trigger: "28",
        },
        {
          value: 3,
          label: localizationStrings.specificHelp,
          trigger: "further_assistance",
        },
        {
          value: 4,
          label: localizationStrings.search,
          trigger: "Search",
        },
        {
          value: 5,
          label: localizationStrings.back,
          trigger: "STORAGE",
        },
      ],
    },
    {
      id: "17", //security choices
      message: localizationStrings.lockOption3Reply,
      trigger: "security-choices",
    },
    {
      id: "security-choices",
      options: [
        {
          value: 1,
          label: localizationStrings.securityOption1,
          trigger: "27",
        },
        {
          value: 2,
          label: localizationStrings.securityOption2,
          trigger: "28",
        },
        {
          value: 3,
          label: localizationStrings.securityOption3,
          trigger: "29",
        },
        {
          value: 4,
          label: localizationStrings.securityOption4,
          trigger: "52",
        },
        {
          value: 5,
          label: localizationStrings.specificHelp,
          trigger: "further_assistance",
        },
        {
          value: 6,
          label: localizationStrings.search,
          trigger: "Search",
        },
        {
          value: 7,
          label: localizationStrings.back,
          trigger: "STORAGE",
        },
      ],
    },
    {
      id: "18", //hardware choice
      message: localizationStrings.lockOption4Reply,
      trigger: "hardware-choices",
    },
    {
      id: "hardware-choices",
      options: [
        {
          value: 1,
          label: localizationStrings.hardwareOption1,
          trigger: "30",
        },
        {
          value: 2,
          label: localizationStrings.hardwareOption2,
          trigger: "31",
        },
        {
          value: 3,
          label: localizationStrings.hardwareOption3,
          trigger: "32",
        },
        {
          value: 4,
          label: localizationStrings.hardwareOption4,
          trigger: "33",
        },
        {
          value: 5,
          label: localizationStrings.hardwareOption5,
          trigger: "51",
        },
        {
          value: 6,
          label: localizationStrings.specificHelp,
          trigger: "further_assistance",
        },
        {
          value: 7,
          label: localizationStrings.search,
          trigger: "Search",
        },
        {
          value: 8,
          label: localizationStrings.back,
          trigger: "STORAGE",
        },
      ],
    },
    {
      id: "19", //other choices
      message: localizationStrings.lockOption5Reply,
      trigger: "other-choices",
    },
    {
      id: "other-choices",
      options: [
        {
          value: 1,
          label: localizationStrings.othersOption1,
          trigger: "34",
        },
        {
          value: 2,
          label: localizationStrings.othersOption2,
          trigger: "35",
        },
        {
          value: 3,
          label: localizationStrings.othersOption3,
          trigger: "36",
        },
        {
          value: 4,
          label: localizationStrings.othersOption4,
          trigger: "37",
        },
        {
          value: 5,
          label: localizationStrings.specificHelp,
          trigger: "further_assistance",
        },
        {
          value: 6,
          label: localizationStrings.search,
          trigger: "Search",
        },
        {
          value: 7,
          label: localizationStrings.back,
          trigger: "STORAGE",
        },
      ],
    },
    {
      id: "39",
      message: localizationStrings.subscriptionOption1Reply,
      trigger: "2ndlogin",
    },
    {
      id: "40",
      message: localizationStrings.subscriptionOption2Reply,
      trigger: "2ndlogin",
    },
    {
      id: "further_assistance",
      message: localizationStrings.furtherAssistance,
      trigger: "41",
    },
    {
      id: "41",
      component: (
        <div>
          <div style={{ height: "12px" }} />
          <p>Tel: (1) 949 558 0160</p>
          <p>Fax: (1) 949 271 5701</p>
          <p>Email: info@digipas.com</p>
        </div>
      ),
      trigger: "2ndlogin",
    },
    {
      id: "42",
      message: localizationStrings.accountOption1Reply,
      trigger: "2ndlogin",
    },
    {
      id: "43",
      message: localizationStrings.accountOption2Reply,
      trigger: "2ndlogin",
    },
    {
      id: "44",
      component: (
        <div>
          <div style={{ height: "12px" }} />
          <p>Tel: (1) 949 558 0160</p>
          <p>Fax: (1) 949 271 5701</p>
          <p>Email: info@digipas.com</p>
        </div>
      ),
      trigger: "2ndlogin",
    },
    {
      id: "45",
      message: localizationStrings.accountOption4Reply,
      trigger: "2ndlogin",
    },
    {
      id: "46",
      message: localizationStrings.accountOption5Reply,
      trigger: "2ndlogin",
    },
    {
      id: "54",
      message: localizationStrings.featuresOption7Reply,
      trigger: "2ndlogin",
    },
    {
      id: "48",
      message: localizationStrings.featuresOption8Reply,
      trigger: "2ndlogin",
    },
    {
      id: "49",
      message: localizationStrings.accountOption6Reply,
      trigger: "2ndlogin",
    },
    {
      id: "50",
      message: localizationStrings.appOption1Reply,
      trigger: "2ndlogin",
    },
    {
      id: "51",
      component: (
        <div>
          <div style={{ height: "12px" }} />
          <p>Tel: (1) 949 558 0160</p>
          <p>Fax: (1) 949 271 5701</p>
          <p>Email: info@digipas.com</p>
        </div>
      ),
      trigger: "2ndlogin",
    },
    {
      id: "52",
      message: localizationStrings.securityOption4Reply,
      trigger: "2ndlogin",
    },
    {
      id: "53",
      message: localizationStrings.accessOption5Reply,
      trigger: "2ndlogin",
    },
    {
      id: "20",
      message: localizationStrings.accessOption1Reply,
      trigger: "2ndlogin",
    },
    {
      id: "21",
      message: localizationStrings.accessOption2Reply,
      trigger: "2ndlogin",
    },
    {
      id: "22",
      component: (
        <div>
          <div style={{ height: "12px" }} />
          <p>Tel: (1) 949 558 0160</p>
          <p>Fax: (1) 949 271 5701</p>
          <p>Email: info@digipas.com</p>
        </div>
      ),
      trigger: "2ndlogin",
    },
    {
      id: "23",
      message: localizationStrings.accessOption4Reply,
      trigger: "2ndlogin",
    },
    {
      id: "24",
      component: (
        <div>
          <div style={{ height: "12px" }} />
          <p>Tel: (1) 949 558 0160</p>
          <p>Fax: (1) 949 271 5701</p>
          <p>Email: info@digipas.com</p>
        </div>
      ),
      trigger: "2ndlogin",
    },
    {
      id: "25",
      message: localizationStrings.multiApprovalOption1Reply,
      trigger: "2ndlogin",
    },
    {
      id: "smart_lock",
      message: localizationStrings.featuresOption6Reply,
      trigger: "2ndlogin",
    },
    {
      id: "26",
      component: (
        <div>
          <div style={{ height: "12px" }} />
          <p>Tel: (1) 949 558 0160</p>
          <p>Fax: (1) 949 271 5701</p>
          <p>Email: info@digipas.com</p>
        </div>
      ),
      trigger: "2ndlogin",
    },
    {
      id: "27",
      component: (
        <div>
          <div style={{ height: "12px" }} />
          <p>Tel: (1) 949 558 0160</p>
          <p>Fax: (1) 949 271 5701</p>
          <p>Email: info@digipas.com</p>
        </div>
      ),
      trigger: "2ndlogin",
    },
    {
      id: "28",
      message: localizationStrings.multiApprovalOption2Reply,
      trigger: "2ndlogin",
    },
    {
      id: "29",
      component: (
        <div>
          <div style={{ height: "12px" }} />
          <p>Tel: (1) 949 558 0160</p>
          <p>Fax: (1) 949 271 5701</p>
          <p>Email: info@digipas.com</p>
        </div>
      ),
      trigger: "2ndlogin",
    },
    {
      id: "30",
      component: (
        <div>
          <div style={{ height: "12px" }} />
          <p>Tel: (1) 949 558 0160</p>
          <p>Fax: (1) 949 271 5701</p>
          <p>Email: info@digipas.com</p>
        </div>
      ),
      trigger: "2ndlogin",
    },
    {
      id: "31",
      component: (
        <div>
          <div style={{ height: "12px" }} />
          <p>Tel: (1) 949 558 0160</p>
          <p>Fax: (1) 949 271 5701</p>
          <p>Email: info@digipas.com</p>
        </div>
      ),
      trigger: "2ndlogin",
    },
    {
      id: "32",
      component: (
        <div>
          <div style={{ height: "12px" }} />
          <p>Tel: (1) 949 558 0160</p>
          <p>Fax: (1) 949 271 5701</p>
          <p>Email: info@digipas.com</p>
        </div>
      ),
      trigger: "2ndlogin",
    },
    {
      id: "33",
      component: (
        <div>
          <div style={{ height: "12px" }} />
          <p>Tel: (1) 949 558 0160</p>
          <p>Fax: (1) 949 271 5701</p>
          <p>Email: info@digipas.com</p>
        </div>
      ),
      trigger: "2ndlogin",
    },
    {
      id: "34",
      message: localizationStrings.othersOption1Reply,
      trigger: "2ndlogin",
    },
    {
      id: "35",
      component: (
        <div>
          <div style={{ height: "12px" }} />
          <p>Tel: (1) 949 558 0160</p>
          <p>Fax: (1) 949 271 5701</p>
          <p>Email: info@digipas.com</p>
        </div>
      ),
      trigger: "2ndlogin",
    },
    {
      id: "36",
      message: localizationStrings.othersOption3Reply,
      trigger: "2ndlogin",
    },
    {
      id: "37",
      message: localizationStrings.othersOption4Reply,
      trigger: "link",
    },
    {
      id: "link",
      component: (
        <div>
          <a
            href="https://www.digipas.com/"
            target="_blank"
            style={{ color: "black", textDecoration: "underline" }}
          >
            digipas.com
          </a>
        </div>
      ),
      trigger: "2ndlogin",
    },
    {
      id: "38",
      message: localizationStrings.contactUs,
      trigger: "2ndlogin",
    },
    {
      id: "history_lock",
      message: localizationStrings.securityOption4Reply,
      trigger: "2ndlogin",
    },
    {
      id: "link-2",
      component: (
        <div>
          <div style={{ height: "12px" }} />
          <p>Tel: (1) 949 558 0160</p>
          <p>Fax: (1) 949 271 5701</p>
          <p>Email: info@digipas.com</p>
        </div>
      ),
      trigger: "2ndlogin",
    },
    {
      id: "Search",
      message: localizationStrings.searching,
      trigger: "type_2",
    },
    {
      id: "type_2",
      user: true,
      trigger: "link4",
    },
    {
      id: "link4",
      component: <Extract />,
      asMessage: true,
    },
    {
      id: "none_found",
      component: <Not_Found />,
      asMessage: true,
    },
    {
      id: "Q1",
      component: <Q1_component />,
      asMessage: true,
    },
    {
      id: "Q2",
      component: <Q2_component />,
      asMessage: true,
    },
    {
      id: "Q3",
      component: <Q3_component />,
      asMessage: true,
    },
    {
      id: "Q4",
      component: <Q4_component />,
      asMessage: true,
    },
    {
      id: "Q5",
      component: <Q5_component />,
      asMessage: true,
    },
    {
      id: "Q6",
      component: <Q6_component />,
      asMessage: true,
    },
    {
      id: "Q7",
      component: <Q7_component />,
      asMessage: true,
    },
    {
      id: "Q8",
      component: <Q8_component />,
      asMessage: true,
    },
    {
      id: "Q4",
      component: <Q4_component />,
      asMessage: true,
    },
    {
      id: "Q9",
      component: <Q9_component />,
      asMessage: true,
    },
    {
      id: "Q10",
      component: <Q10_component />,
      asMessage: true,
    },
    {
      id: "Q11",
      component: <Q11_component />,
      asMessage: true,
    },
    {
      id: "Q12",
      component: <Q12_component />,
      asMessage: true,
    },
    {
      id: "Q13",
      component: <Q13_component />,
      asMessage: true,
    },
    {
      id: "Q14",
      component: <Q14_component />,
      asMessage: true,
    },
    {
      id: "Q15",
      component: <Q15_component />,
      asMessage: true,
    },
    {
      id: "Q16",
      component: <Q16_component />,
      asMessage: true,
    },
    {
      id: "Q17",
      component: <Q17_component />,
      asMessage: true,
    },
    {
      id: "Q18",
      component: <Q18_component />,
      asMessage: true,
    },
    {
      id: "Q19",
      component: <Q19_component />,
      asMessage: true,
    },
    {
      id: "Q20",
      component: <Q20_component />,
      asMessage: true,
    },
    {
      id: "Q21",
      component: <Q21_component />,
      asMessage: true,
    },
    {
      id: "Q22",
      component: <Q22_component />,
      asMessage: true,
    },
    {
      id: "Q23",
      component: <Q23_component />,
      asMessage: true,
    },
    {
      id: "Q24",
      component: <Q24_component />,
      asMessage: true,
    },
    {
      id: "Q25",
      component: <Q25_component />,
      asMessage: true,
    },
    {
      id: "Q26",
      component: <Q26_component />,
      asMessage: true,
    },
    {
      id: "Q27",
      component: <Q27_component />,
      asMessage: true,
    },
    {
      id: "lock",
      component: <Lock />,
      asMessage: true,
    },
    {
      id: "User_Management_comp",
      component: <User_Management_comp />,
      asMessage: true,
    },
    {
      id: "MultiApproval",
      component: <MultiApproval />,
      asMessage: true,
    },
    {
      id: "Audit_Trails",
      component: <Audit_Trails />,
      asMessage: true,
    },
    {
      id: "Retract_Access",
      component: <Retract_Access />,
      asMessage: true,
    },
    {
      id: "Plan_subscription",
      component: <Plan_subscription />,
      asMessage: true,
    },
    {
      id: "GrantAccess",
      component: <GrantAccess />,
      asMessage: true,
    },
    {
      id: "cancel",
      message: localizationStrings.foundAnswer,
      trigger: "2ndlogin",
    },
  ];

  return (
    <ThemeProvider theme={theme}>
      <style>{customStyles}</style>
      <div />{" "}
      <ChatBot
        key={language}
        headerTitle={localizationStrings.chatHeader}
        floating={true}
        steps={steps}
        enableMobileAutoFocus={false}
        enableSmoothScroll={false}
        bubbleOptionStyle={bubbleOptionStyle}
        placeholder={localizationStrings.inputPlaceholder}
        botDelay={1000}
        userDelay={500}
        // cache={true}
      />
    </ThemeProvider>
  );
};

export default Bot;
